module.exports = __webpack_public_path__ + "static/media/Settings.8c7c90e0.svg";